// extracted by mini-css-extract-plugin
export default {"container":"DeleteProfile_container__Cwzwh"};